import React from "react";
import MainScreen from "../components/MainScreen";

export default function Countdown() {
  return <MainScreen />;
}
